import $ from 'jquery'

let $resort_container = $('.resort-gallery-container').innerWidth()
let $resort_image = $('.resort-gallery-image')
let column_count = Math.floor($resort_container / $resort_image.innerWidth())
let image_count = column_count * 2
let $load_more_button = $('.resort-load-more-button')

if($resort_container) {
    if($(window).outerWidth() > 1159) {
        console.log(image_count/2, column_count * 2)
        if($resort_image.length <= (column_count * 2)) {
            $load_more_button.hide()
        }
        $('.resort-gallery-container .resort-gallery-image:gt(' + (column_count * 2 - 1) + ')').hide();
    } else {
        if($resort_image.length <= 6) {
            $load_more_button.hide()
        }
        $('.resort-gallery-container .resort-gallery-image:gt(5)').hide();
    }

    $load_more_button.click(function() {
        if($(window).outerWidth() > 1159) {
            $('.resort-gallery-container .resort-gallery-image:hidden:lt(' + (column_count * 2) + ')').show();
            image_count += column_count * 2
        } else {
            $('.resort-gallery-container .resort-gallery-image:hidden:lt(6)').show();
            image_count += 6
        }
        if (image_count >= $resort_image.length) {
            $load_more_button.hide()
        }
    });
}


